import {addChild} from './index'

let deferredPrompt

const btnAdd = addChild(document.body,'button',{
  textContent: 'install'
  ,'class': 'hidden'
  ,style: 'position:absolute;left:0;top:0;z-index:999;display:none;'
})

window.addEventListener('beforeinstallprompt',(e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault()
  // Stash the event so it can be triggered later.
  deferredPrompt = e
  btnAdd.style.display = 'block'
})

btnAdd.addEventListener('click',() => {
  // hide our user interface that shows our A2HS button
  btnAdd.style.display = 'none'
  // Show the prompt
  deferredPrompt.prompt()
  // Wait for the user to respond to the prompt
  deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome==='accepted'){
          console.log('User accepted the A2HS prompt')
        } else {
          console.log('User dismissed the A2HS prompt')
        }
        deferredPrompt = null
      })
})


// WEBPACK FOOTER //
// ./src/js/util/webapp.js